import * as React from "react";
import Form from "components/organisims/Form";
import { show } from "settings/FormSettings";

export default function Show() {
  return <Form dataType="show" formParams={show} />;
}
